import { RootState } from "../../../../types/RootState.js";
import { createSelector } from "@reduxjs/toolkit";
import { initialState } from "./slice.js";

const selectDomain = (state: RootState) => state?.useWalletState || initialState;

export const selectWalletState = createSelector([selectDomain], (useWalletState) => useWalletState.wallet);

export const isLoadingWallet = createSelector([selectDomain], (userStateState) => userStateState.isLoading);
